/**
 * 조회 전용(VIEWER) 계정의 쓰기 잠금 문구(유저 플로우 제안 7, 2026-11-03) — 버튼은 숨기지 않고 잠그는 곳에 이 문구를 이유로 붙인다.
 * 역할 판정은 StorageContext 의 isAdmin(ADMIN · SUPER) 하나 — 서버도 같은 기준으로 막는다(403).
 */
export const READ_ONLY_REASON = '조회 전용 계정은 할 수 없습니다';
